var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrangeStars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 31,
    viewBox: "0 0 154 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1672 0.36377L19.5878 10.8913H30.6571L21.7018 17.3976L25.1224 27.9251L16.1672 21.4188L7.21196 27.9251L10.6326 17.3976L1.67732 10.8913H12.7466L16.1672 0.36377Z",
    fill: "#FF915A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6386 0.36377L50.0592 10.8913H61.1285L52.1733 17.3976L55.5939 27.9251L46.6386 21.4188L37.6834 27.9251L41.104 17.3976L32.1488 10.8913H43.218L46.6386 0.36377Z",
    fill: "#FF915A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1096 0.36377L80.5302 10.8913H91.5994L82.6442 17.3976L86.0648 27.9251L77.1096 21.4188L68.1543 27.9251L71.5749 17.3976L62.6197 10.8913H73.689L77.1096 0.36377Z",
    fill: "#FF915A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.581 0.36377L111.001 10.8913H122.071L113.115 17.3976L116.536 27.9251L107.581 21.4188L98.6255 27.9251L102.046 17.3976L93.0909 10.8913H104.16L107.581 0.36377Z",
    fill: "#FF915A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M138.052 0.36377L141.472 10.8913H152.542L143.586 17.3976L147.007 27.9251L138.052 21.4188L129.096 27.9251L132.517 17.3976L123.562 10.8913H134.631L138.052 0.36377Z",
    fill: "#FF915A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeStars);
export default __webpack_public_path__ + "static/media/orange_stars.3765cde61ceaae42682853fba604c8f9.svg";
export { ForwardRef as ReactComponent };